import { render, staticRenderFns } from "./cms-quotes.vue?vue&type=template&id=17e18d0b"
import script from "./cms-quotes.vue?vue&type=script&lang=js"
export * from "./cms-quotes.vue?vue&type=script&lang=js"
import style0 from "./cms-quotes.vue?vue&type=style&index=0&id=17e18d0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports